import { ClientSideTable } from 'Presentation/Components/Table'
import ProductCell from './Cells/ProductCell'
import QuantityCell from './Cells/QuantityCell'
import PriceCell from './Cells/PriceCell'

import clsx from 'clsx'
import moment from 'moment'
import { useLang } from '_metronic/i18n/Metronici18n'

interface Props {
	isLoading?: boolean
	uuId: string
	code: string
	buyerReviewed: boolean
	status: string
	statusTitleEn: string
	statusTitleTh: string
	product: {
		nameEn: string
		nameTh: string
		shortDescription: string
		featurePicturePath: string
	}
	items: {
		id: string
		isFixed: boolean
		price: string
		quantity: number
		remark: string | null
		title: string | null
		total: string
		createdAt: string
		oemRequestItemId: number
		productId: number
		product: {
			id: number
			nameTh: string
			nameEn: string
			slug: string
			shortDescription: string
			longDescription: string
			shortDescriptionEn: string | null
			longDescriptionEn: string | null
			isActive: boolean
			productLine: {
				id: number
				nameTh: string
				descriptionTh: string
				nameEn: string
				descriptionEn: string
				sortOrder: number
				slug: string
				createdAt: string
				updatedAt: string
				isActive: boolean
				featurePicturePath: string
				parentId: number | null
				parentTitle: string | null
			}
		}
	}[]
	createdAt: string
	viewDetail?: (uuId: string) => void
}

const KumopackContractOverviewCard: React.FC<Props> = ({
	isLoading,
	buyerReviewed,
	uuId,
	code,
	status,
	statusTitleEn,
	statusTitleTh,
	product,
	items,
	createdAt,
	viewDetail,
}) => {
	const lang = useLang()
	let buttonClass = ''

	// Pending && Produce Sample & Sample has been sent
	if (status === '10' || status === '15' || status === '20' || status === '30') {
		buttonClass = 'btn-kumopack-primary-700 text-kumopack-base-white'
	}
	// Confirm Sample & Producing & Delivering
	else if (status === '40' || status === '50' || status === '60') {
		buttonClass = 'btn-kumopack-secondary-700 text-kumopack-base-white'
	}
	// Delivered & Completed
	else if (status === '70' || status === '80') {
		buttonClass = 'btn-kumopack-success-700 text-kumopack-base-white'
	}
	// Cancelled
	else if (status === '90') {
		buttonClass = 'btn-kumopack-error-700 text-kumopack-base-white'
	}

	const columns: any[] = [
		{
			Header: 'สินค้าที่สั่งผลิต',
			accessor: 'product',
			minWidth: 400,
			Cell: ({ value }: any) => <ProductCell {...value} />,
		},
		{
			Header: () => <div className="text-end">จำนวนที่สั่งผลิต</div>,
			accessor: 'quantity',
			minWidth: 150,
			Cell: ({ value }: any) => (
				<QuantityCell quantity={value} unit={lang === 'en' ? 'pcs' : 'ชิ้น'} />
			),
		},
		{
			Header: () => <div className="text-end">ราคาต่อชิ้น</div>,
			accessor: 'price',
			minWidth: 150,
			Cell: ({ value }: any) => <PriceCell price={value} />,
		},
		{
			Header: () => <div className="text-end">ยอดรวม</div>,
			accessor: 'total',
			minWidth: 150,
			Cell: ({ value }: any) => <PriceCell price={value} />,
		},
	]

	return (
		<div className="card border border-kumopack-grey-200">
			{/* begin:: Header */}
			<div className="card-header">
				<div
					className={clsx(
						'd-flex flex-column flex-xl-row justify-content-between w-100 my-5 align-items-center',
						{
							// 'align-items-start': isDone,
							// 'align-items-center': !isDone,
						}
					)}>
					{/* begin:: Title */}
					<div className="w-100 h-100">
						<div
							className="d-flex flex-row align-items-center justify-content-between h-100"
							style={{ columnGap: '12px' }}>
							<div>
								<h4
									className="d-inline-block text-kumopack-primary-600 fw-bold mb-0 me-1 hover-underline cursor-pointer"
									onClick={() => viewDetail && viewDetail(uuId)}>
									เลขที่คำร้อง: {code}
								</h4>
								{/* <div
									className={`d-inline-block badge text-white ${buttonClass}`}
									style={{ borderRadius: '16px' }}>
									คำร้องใหม่
								</div> */}
							</div>
						</div>
					</div>
					{/* end:: Title */}

					{/* begin:: Status */}
					<div
						className={clsx('d-flex  mt-5 mt-xl-0 flex-row align-items-center', {
							// 'flex-column flex-xl-row align-items-start align-items-xl-center': isDone,
							// 'flex-row align-items-center': !isDone,
						})}
						style={{ gap: '12px', whiteSpace: 'nowrap' }}>
						{(status === '70' || status === '80') && buyerReviewed === false && (
							<button
								className="btn btn-sm white-button text-kumopack-grey-900"
								onClick={() => viewDetail && viewDetail(uuId)}>
								ให้คะแนน
							</button>
						)}

						<button
							className={`btn btn-sm fw-bold ${buttonClass}`}
							style={{ whiteSpace: 'nowrap' }}
							onClick={() => viewDetail && viewDetail(uuId)}>
							{statusTitleTh}
						</button>
					</div>
					{/* end:: Status */}
				</div>
			</div>

			<hr
				style={{
					background: 'transparent',
					borderBottom: '1px solid #CCC',
					borderTop: 0,
					borderLeft: 0,
					borderRight: 0,
					margin: 0,
				}}
			/>

			{/* begin:: Body */}
			<div className="card-body p-0">
				<ClientSideTable
					isGrey
					isLoading={isLoading}
					data={items}
					columns={columns}
					items_per_page={10}
				/>

				<hr
					style={{
						background: 'transparent',
						borderBottom: '1px solid #CCC',
						borderTop: 0,
						borderLeft: 0,
						borderRight: 0,
						margin: 0,
					}}
				/>

				<div className="d-flex flex-row justify-content-between align-items-center p-5">
					<div className="text-kumopack-grey-700">
						สร้างเมื่อวันที่ {moment(createdAt).format('DD-MM-YYYY')}
					</div>
					<button
						className="btn btn-kumopack-primary-600 text-kumopack-base-white p-2 fs-7"
						onClick={() => viewDetail && viewDetail(uuId)}>
						รายละเอียดเพิ่มเติม
					</button>
				</div>
			</div>
			{/* end:: Body */}
		</div>
	)
}

export default KumopackContractOverviewCard
